<template>
  <div class="search-results">
    <div v-if="results?.length > 0" class="search-results__count">
      <span class="search-results__count-title">
        {{ $t("searchResult | title | foundMoreThenOne") }}
      </span>
    </div>
  </div>
</template>
<script>
/*
  A component for displaying a table of results if more than 1 transaction/address is found. 
  It is currently impossible to output more than 1 result at the endpoint. 
  Such functionality is planned in the future.
 */
export default {
  name: "SearchResults",
  props: {
    results: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.search-results {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  margin-bottom: 16px;

  &__count {
    word-break: break-word;

    &-title {
      display: block;
      font-weight: 600;
      font-size: 20px;
      line-height: 26px;
      text-align: center;
    }
  }
}
</style>
